'use client';

import '../../../styles/pages/common.css';

import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { LoginPage } from '@teuteuf-games/login-page';
import { getSiteMode } from '@wt/utilities/siteMode';
import { getAuthServerUrl } from '@wt/utilities/database';

const getDefaultReferrer = () => {
  if (getSiteMode() === 'wheretaken') return 'wheretaken-2.0';
  if (getSiteMode() === 'whentaken-movies') return 'whentaken-movies';
  return 'whentaken';
};

export const LoginContent = () => {
  const router = useRouter();

  // window isn't available during SSR/prerender, so default by site mode
  // and correct to the localhost referrer after mount.
  const [referrer, setReferrer] = useState(getDefaultReferrer);
  useEffect(() => {
    if (window.location.href.includes('localhost')) {
      setReferrer('localhost-3001');
    }
  }, []);

  return (
    <div className="flex h-full flex-1 grow flex-col items-center px-4 md:px-8">
      <div className="my-6 flex max-w-4xl flex-col space-y-6 rounded-3xl p-4 text-lg md:bg-base-200 md:p-6">
        <div className="flex w-full flex-row items-center justify-between">
          <div onClick={() => router.back()}>
            <ChevronLeftRoundedIcon className="m-0 fill-current text-2xl leading-none hover:cursor-pointer" />
          </div>
          <div className="mx-20 grow text-center">
            <span className="text-xl font-medium lg:text-4xl">Login</span>
          </div>
          <Link href={'/game'} className="hidden md:flex">
            <CloseRoundedIcon className="m-0 fill-current text-2xl leading-none" />
          </Link>
        </div>
        <LoginPage authServerUrl={getAuthServerUrl()} referer={referrer} />
      </div>
    </div>
  );
};
